import styles from './Modal.module.scss';

// Footer Component
export interface ModalFooterProps {
  /**
   * Footer content
   */
  children: React.ReactNode;
  
  /**
   * Optional custom class for the footer
   */
  className?: string;
  
  /**
   * Whether to show a divider above the footer
   * @default true
   */
  divider?: boolean;
}

export const ModalFooter: React.FC<ModalFooterProps> = ({ 
  children, 
  className = '',
  divider = true
}) => {
  return (
    <div className={`${styles.modalFooter} ${divider ? styles.withDivider : ''} ${className}`}>
      {children}
    </div>
  );
};

